// assets/js/modules/projectGridReflow.js
//
// Le rythme desktop de .project-grid alterne des lignes de 2 puis 3 items
// (voir _project-grid.scss). Ce rythme est positionnel : il ne peut pas
// survivre au filtrage en CSS seul (nth-child compte aussi les items masqués).
// On recalcule donc le regroupement 2/3 à partir du rang des items visibles,
// et on pose une classe par item (is-pair / is-triple / is-lone) que le CSS
// utilise à la place de nth-child.
//
// Algorithme glouton : on consomme des groupes de taille 2 puis 3 (en
// alternance) tant qu'il reste assez d'items. Le reste ne peut jamais être
// que 0, 1 ou 2 (jamais 3 ou 4) — d'où les seuls trois cas gérés ci-dessous.

let ac = null;

function _update() {
    const grid = document.querySelector('.project-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.project-item:not(.is-filtered-out)'));
    items.forEach(item => item.classList.remove('is-pair', 'is-triple', 'is-lone'));

    let idx = 0;
    let remaining = items.length;
    let size = 2;

    while (remaining >= size) {
        const cls = size === 2 ? 'is-pair' : 'is-triple';
        for (let k = 0; k < size; k++) items[idx++].classList.add(cls);
        remaining -= size;
        size = size === 2 ? 3 : 2;
    }

    if (remaining === 1) {
        items[idx].classList.add('is-lone');
    } else if (remaining === 2) {
        items[idx].classList.add('is-pair');
        items[idx + 1].classList.add('is-pair');
    }
}

export function init() {
    if (!document.querySelector('.project-grid')) return;

    ac = new AbortController();
    window.addEventListener('resize', _update, { signal: ac.signal });

    _update();
}

export function destroy() {
    ac?.abort();
    ac = null;
}
